export default {
  field_from_api: {
    clue: {
      name: '线索',
      is_rate: false
    },
    arrived: {
      name: '到店',
      is_rate: false
    },
    arrived_rate: {
      name: '到店率',
      is_rate: true
    },
    deal_rate: {
      name: '成交率',
      is_rate: true
    }
  },
  getData (params) {
    this.$rest.dataAnalysis.getClueToDeal(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
